import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OverviewTab } from "@/components/workflow/OverviewTab";
import { AgentDashboard } from "@/components/agents/AgentDashboard";
import { SourcesTab } from "@/components/workflow/SourcesTab";
import { LeadsTab } from "@/components/workflow/LeadsTab";
import { SequencesTab } from "@/components/workflow/SequencesTab";
import { NewslettersTab } from "@/components/workflow/NewslettersTab";
import { MonitoringTab } from "@/components/workflow/MonitoringTab";
import { MetricsTab } from "@/components/workflow/MetricsTab";

export const DashboardTabs = () => {
  return (
    <Tabs defaultValue="overview" className="space-y-8">
      <TabsList className="inline-flex h-12 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground w-full grid grid-cols-8 lg:grid-cols-8">
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="agents">Agents</TabsTrigger>
        <TabsTrigger value="sources">Sources</TabsTrigger>
        <TabsTrigger value="leads">Leads</TabsTrigger>
        <TabsTrigger value="sequences">Sequences</TabsTrigger>
        <TabsTrigger value="newsletters">Newsletters</TabsTrigger>
        <TabsTrigger value="monitoring">Monitoring</TabsTrigger>
        <TabsTrigger value="metrics">Metrics</TabsTrigger>
      </TabsList>

      <TabsContent value="overview">
        <OverviewTab
          currentTopic={null}
          topicLoading={false}
          sources={[]}
          sourcesLoading={false}
          agentMetrics={[]}
        />
      </TabsContent>

      <TabsContent value="agents">
        <AgentDashboard />
      </TabsContent>

      <TabsContent value="sequences">
        <SequencesTab />
      </TabsContent>

      <TabsContent value="sources">
        <SourcesTab />
      </TabsContent>

      <TabsContent value="leads">
        <LeadsTab />
      </TabsContent>

      <TabsContent value="newsletters">
        <NewslettersTab />
      </TabsContent>

      <TabsContent value="monitoring">
        <MonitoringTab />
      </TabsContent>

      <TabsContent value="metrics">
        <MetricsTab />
      </TabsContent>
    </Tabs>
  );
};